import React from 'react';
import { Aggregations } from '../interfaces';
import { reverseCamelCase } from '../utility';
import { Link } from 'react-router-dom';
import { uniq } from 'lodash';
import { ListGroup } from 'react-bootstrap';
/**
 * @description Properties for the Facets component
 * @interface
 */
interface Props {
  searchQuery: string;
  aggregations?: Aggregations;
  filters?: string | null;
  order?: string[]; // aggregation order
}

/**
 * @description Component to control the ElasticSearch facets.
 * @param {Props} props
 * @return {JSX.Element}
 */
const Facets = (props: Props): JSX.Element => {
  const aggs: Aggregations = props.aggregations ? props.aggregations : {};

  const filters = props.filters
    ? uniq(props.filters.split(',')).join(',') + ','
    : '';

  return (
    <React.Fragment>
      {props.order
        ? props.order.map((key) => (
            <div key={key}>
              <strong>
                {reverseCamelCase(key)
                  .substring(0, reverseCamelCase(key).length - 1)
                  .replace('Num', '')
                  .replace('Ecosystem Name', 'Region')}
              </strong>
              <ListGroup className="mb-3 text-sm">
                {aggs[key].map((bucket) => (
                  <Link
                    className="list-group-item list-group-item-action text-primary"
                    key={bucket.key}
                    to={{
                      search: `?q=${
                        props.searchQuery
                      }&a=${filters}${key.substring(0, key.length - 1)}|${
                        bucket.key
                      }`,
                    }}
                  >
                    {bucket.key} ({bucket.count})
                  </Link>
                ))}
              </ListGroup>
            </div>
          ))
        : null}
      {Object.keys(aggs).length > 0 ? (
        <div className="text-center">
          <Link
            to={{
              search: `?q=${props.searchQuery}&a=&page=1`,
            }}
          >
            clear filters
          </Link>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Facets;
